import React, { useState, useEffect } from 'react';
import { getPendingConfirmations } from '../../services/videoActivationAPI';

const SpeakerNotificationBanner = ({ onIdentifyClick, onJobId }) => {
  const [pendingCount, setPendingCount] = useState(0);
  const [jobIds, setJobIds] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    getPendingConfirmations()
      .then(data => {
        setPendingCount(data.count);
        setJobIds(data.job_ids || []);
        if (onJobId && data.job_ids?.length > 0) {
          onJobId(data.job_ids[0]);
        }
      })
      .catch(() => {});
  }, [onJobId]);

  if (!pendingCount || dismissed) return null;

  return (
    <div style={{
      background: '#FFF7F0',
      border: '1px solid #F0C070',
      borderRadius: '8px',
      padding: '10px 14px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      marginBottom: '14px',
    }}>
      {/* Orange dot */}
      <div style={{
        width: '8px', height: '8px', borderRadius: '50%',
        background: '#E65100', flexShrink: 0,
      }} />

      <div style={{ flex: 1, fontSize: '13px', color: '#7A3000', lineHeight: 1.5 }}>
        We found{' '}
        <strong>{pendingCount} unidentified voice{pendingCount !== 1 ? 's' : ''}</strong>
        {' '}in your family videos.
        Tell us who they are to unlock their wisdom moments.
      </div>

      <button
        onClick={() => onIdentifyClick && onIdentifyClick(jobIds[0])}
        style={{
          background: '#E65100', color: 'white',
          border: 'none', borderRadius: '6px',
          padding: '6px 12px', fontSize: '12px',
          fontWeight: '600', cursor: 'pointer',
          whiteSpace: 'nowrap', flexShrink: 0,
          minHeight: '32px',
        }}
      >
        Identify voices
      </button>

      <button
        onClick={() => setDismissed(true)}
        style={{
          background: 'none', border: 'none',
          color: '#aaa', cursor: 'pointer',
          fontSize: '16px', padding: '0 4px',
          flexShrink: 0,
        }}
        aria-label="Dismiss"
      >
        &times;
      </button>
    </div>
  );
};

export default SpeakerNotificationBanner;
